import React from 'react';

import { Text } from '@yandex-360/orb-components/dist/components/Text';

import SvgImage from '../../../../shared/components/svg-image';
import { ImageName } from '../../../../shared/components/svg-image/images';
import styles from './styles.css';

interface EmptyStub {
    imageName?: ImageName;
    title: string;
    text: string;
}

const EmptyStub = ({ imageName, title, text }: EmptyStub) => {
    return (
        <div className={styles.stub}>
            <div className={styles.stubInner}>
                {imageName && <SvgImage className={styles.stubImage} imageName={imageName} />}
                <div className={styles.stubTitle}>
                    <Text typography="heading-sm">{title}</Text>
                </div>
                <div className={styles.stubText}>
                    <Text typography="body-lg-regular">{text}</Text>
                </div>
            </div>
        </div>
    );
};

export { EmptyStub };
